<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Theater of God’s Glory: Calvin, Creation, and the Liturgical Arts</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<p class="OT" id="abb001"><a id="page_xiv"></a><a href="#/xhtml/contents#abbreviations">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr><td class="tdleft">AB</td><td class="tdleft">Anchor Bible</td></tr>
<tr><td class="tdleft">AGJU</td><td class="tdleft">Arbeiten zur Geschichte des antiken Judentums und des Urchristentums</td></tr>
<tr><td class="tdleft">BECNT</td><td class="tdleft">Baker Exegetical Commentary on the New Testament</td></tr>
<tr><td class="tdleft"><i>CO</i></td><td class="tdleft"><i>Ioannis Calvini Opera Quae Supersunt Omnia</i> (Baum, Cunitz, Reuss)</td></tr>
<tr><td class="tdleft"><i>Comm.</i></td><td class="tdleft"><i>Commentaries of John Calvin</i></td></tr>
<tr><td class="tdleft"><i>CR</i></td><td class="tdleft"><i>Corpus Reformatorum</i> (Braunschweig, 1834–)</td></tr>
<tr><td class="tdleft">ETS</td><td class="tdleft">Evangelical Theological Society</td></tr>
<tr><td class="tdleft"><i>HTR</i></td><td class="tdleft"><i>Harvard Theological Review</i></td></tr>
<tr><td class="tdleft">ICC</td><td class="tdleft">International Critical Commentary</td></tr>
<tr><td class="tdleft"><i>Institutes</i></td><td class="tdleft">1559 <i>Institutes of the Christian Religion</i> (McNeill/Battles)</td></tr>
<tr><td class="tdleft"><i>Institutes</i> (1536)</td><td class="tdleft">1536 <i>Institutes of the Christian Religion</i> (Battles)</td></tr>
<tr><td class="tdleft">IVPNTCS</td><td class="tdleft">InterVarsity Press New Testament Commentary Series</td></tr>
<tr><td class="tdleft"><i>JBL</i></td><td class="tdleft"><i>Journal of Biblical Literature</i></td></tr>
<tr><td class="tdleft"><i>JETS</i></td><td class="tdleft"><i>Journal of the Evangelical Theological Society</i></td></tr>
<tr><td class="tdleft">JSNTSup</td><td class="tdleft">Journal for the Study of the New Testament, Supplement Series</td></tr>
<tr><td class="tdleft">NICNT</td><td class="tdleft">New International Commentary on the New Testament</td></tr>
<tr><td class="tdleft">NIGTC</td><td class="tdleft">New International Greek Testament Commentary</td></tr>
<tr><td class="tdleft">SBLDS</td><td class="tdleft">Society of Biblical Literature Dissertation Series</td></tr>
<tr><td class="tdleft">SHR</td><td class="tdleft">Studies in the History of Religions</td></tr>
<tr><td class="tdleft">SNTSMS</td><td class="tdleft">Society for New Testament Studies Monograph Series</td></tr>
<tr><td class="tdleft"><i>Tracts and Treatises</i></td><td class="tdleft"><i>Tracts and Treatises of John Calvin</i> (Beveridge)</td></tr>
<tr><td class="tdleft">WBC</td><td class="tdleft">Word Bible Commentary</td></tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?d043caf6